// extracted by mini-css-extract-plugin
module.exports = {"dealer-list":"DealerSelection_dealer-list__HnvYk","ant-list-items":"DealerSelection_ant-list-items__2FnQb"};